import React, { useContext, useEffect, useState } from "react";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ContentLayout from "../../component/ContentLayout";
import { useParams } from "react-router-dom";
import { Context } from "../../component/Context/ErrorContext";
import axios from "../../util/axios";
import CompanyModal from "../../component/CompanyModal";

const Company = () => {
  const { setError } = useContext(Context);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [companyData, setCompanyData] = useState<any>(null);
  const [isUserModal, setIsUserModal] = useState("");
  const [modalLoading, setModalLoading] = useState(false);
  const [company, setCompany] = useState<any>({
    id: 0,
    name: "",
    domain: "",
    contact_email: "",
    password: "",
    phone: "",
    address: "",
    latitude: "",
    longitude: "",
    total_amount: "",
    count_of_current_employee: "",
    number_of_current_employee: "",
  });

  const getCompanyData = async (id?: any) => {
    setLoading(true);
    axios({
      URL: `/omw/admin/get-company-subscription/${id || params?.id}`,
      method: "GET",
    })
      .then((res) => {
        const data = res?.data?.data;
        setCompanyData(data);
      })
      .catch((err) => setError(err?.response?.data?.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (params?.id) {
      getCompanyData(params?.id);
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params?.id]);

  const updateCompany = async () => {
    setModalLoading(true);
    const data = {
      ...company,
    };
    await axios({
      URL: `/omw/admin/update-company-subscription/${params?.id}`,
      method: "PATCH",
      data: data,
    })
      .then((res: any) => {
        getCompanyData(params?.id);
      })
      .catch((err) => {
        setError(err.response?.data?.message);
      })
      .finally(() => {
        setModalLoading(false);
      });
  };

  return (
    <ContentLayout className={"items-start"}>
      <div className={"bg-white w-full rounded-2xl flex flex-col"}>
        <div
          className={"flex p-4 gap-5 md:flex-row flex-col-reverse flex-wrap"}
        >
          <div className={"flex flex-col w-full max-w-[500px] gap-5"}>
            <div className={"flex justify-between gap-2"}>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Name</p>
                <p className={"text-sm text-left"}>
                  {companyData?.name || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Domain</p>
                <p className={"text-sm text-left"}>
                  {companyData?.domain || "-"}
                </p>
              </div>
            </div>
            <div className={"flex justify-between gap-2"}>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>
                  Email Address{" "}
                  <ContentCopyIcon
                    className={"ml-2 cursor-pointer"}
                    onClick={() =>
                      navigator.clipboard.writeText(companyData?.contact_email)
                    }
                  />
                </p>
                <p className={"text-sm text-left"}>
                  {companyData?.contact_email || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>
                  Phone{" "}
                  <ContentCopyIcon
                    className={"ml-2 cursor-pointer"}
                    onClick={() =>
                      navigator.clipboard.writeText(companyData?.phone)
                    }
                  />
                </p>
                <p className={"text-sm text-left"}>
                  {companyData?.phone || "-"}
                </p>
              </div>
            </div>
            <div className={"flex justify-between gap-2"}>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>
                  Current Employee
                </p>
                <p className={"text-sm text-left"}>
                  {companyData?.number_of_current_employee || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>
                  Count Of Current Employee
                </p>
                <p className={"text-sm text-left"}>
                  {companyData?.count_of_current_employee || "-"}
                </p>
              </div>
            </div>
            <div className={"flex justify-between gap-2"}>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Longitude</p>
                <p className={"text-sm text-left"}>
                  {companyData?.longitude || "-"}
                </p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Latitude</p>
                <p className={"text-sm text-left"}>
                  {/*{companyData?.dob || moment().format("MM-DD-YYYY")}*/}
                  {companyData?.latitude}
                </p>
              </div>
              <div className={"flex flex-col flex-1 h-[57px]"}>
                <p className={"text-base font-bold text-left"}>Address</p>
                <p className={"text-sm text-left"}>{companyData?.address}</p>
              </div>
            </div>
            <div className={"flex justify-between gap-2"}>
              <button
                className={
                  "bg-primary text-white p-3 w-40 rounded-2xl disabled:cursor-not-allowed disabled:opacity-70 opacity-100"
                }
                onClick={() => {
                  setIsUserModal("Update");
                  setCompany({
                    ...companyData,
                    id: params?.id,
                  });
                }}
                disabled={loading}
              >
                Edit
              </button>
            </div>
          </div>
          <div className={"flex flex-col flex-1 justify-between"}>
            <div className={"flex flex-col gap-5 items-start md:items-end"}>
              <p className={"text-4xl font-bold text-right"}>Total Amount: </p>
              <p className={"text-4xl text-right"}>
                ${companyData?.total_amount || 0}
              </p>
            </div>
          </div>
        </div>
      </div>

      <CompanyModal
        open={isUserModal}
        onClose={() => setIsUserModal("")}
        company={company}
        setCompany={setCompany}
        onSubmit={updateCompany}
        isEdit
        loading={modalLoading}
      />
    </ContentLayout>
  );
};

export default Company;
